import { sportingAPI } from 'services/sporting/api';

export const getAvailableSmsCount = async (): Promise<number> => {
  const { limit } = await sportingAPI.service.getAvailableSmsCount();

  return limit;
};
